t = require('app/scripts/views/internal/teacup-with-helpers')('board_copy')
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = ->
  t.mustacheBlock 'loading', ->
    t.div '.spinner.loading'
  t.mustacheBlockInverted 'loading', ->
    t.form ->

      t.label { for: 'boardNewTitle' }, ->
        t.format 'title'
      t.input '.non-empty.js-autofocus', {
        id: 'boardNewTitle',
        type: 'text',
        name: 'name',
        placeholder: t.mustacheVar('placeholder'),
        value: t.mustacheVar('boardNameInputValue'),
        dir: 'auto'
      }

      t.div { class: t.mustacheBlock('hideOrg', (-> 'hide')) }, ->
        t.div '.u-clearfix', ->
          t.label '.u-float-left', { style: 'margin-right: 8px;' }, ->
            t.format 'organization'
          t.mustacheBlock 'canAddToOrgs', ->
            t.a '.icon-sm.icon-information.dark-hover.js-helper-add-org', { href: '#' }

        showFeature = featureFlagClient.get('enterprise.restrict-moves-and-copies-into-teams-within-enterprise', false)
        if showFeature
          t.mustacheBlock 'hasEnterprise', ->
            t.mustacheBlock 'enterpriseName', ->
              if !t.mustacheVar('showPrivateBoardsOptionForEntBoards')
                t.p '.quiet', ->
                  t.format 'board-can-only-be-copied-to-teams-within-org', { enterpriseName: t.mustacheVar('enterpriseName') }

        t.mustacheBlockInverted 'canAddToOrgs', ->
          t.p '.quiet', { style: 'margin-bottom: 16px;' }, ->
            t.format 'organization-whisk-n-tsk'
            t.text ' '
            t.a '.js-create-org', { href: '#' }, ->
              t.format 'create-an-organization'

        t.select { name: 'org-id', class: t.mustacheBlockInverted('canAddToOrgs', (-> 'hide')) }, ->
          if !t.mustacheVar('hasEnterprise') || t.mustacheVar('showPrivateBoardsOptionForEntBoards')
            if !t.mustacheVar('toTemplate')
              t.option { value: '' }, ->
                t.format 'none'
          t.mustacheBlock 'orgs', ->
            t.optionSelected t.mustacheVar('selectOrg'), { value: t.mustacheVar('id') }, ->
              t.text t.mustacheVar('displayName')

      t.div '.board-limits-upgrade-ad.js-board-limits-upgrade-ad.hide', ->
        t.p ->
          if t.mustacheVar('isDesktop')
            t.format 'board-cant-be-copied-because-of-board-limits-desktop'
          else
            t.format 'board-cant-be-copied-because-of-board-limits'

      t.div '.js-permissions.hide', ->
        t.input { type: 'hidden', name: 'permissionLevel', value: t.mustacheVar('pLevel') }

        t.p '.quiet.js-vis-display'

        t.ul '.pop-over-list.js-vis-chooser.hide'

        t.p '.error.u-bottom.js-no-valid-org-privs.u-clearfix.hide'

        t.div '.js-confirm-public-message.hide', ->
          t.p t.mustacheVar('publicConfirmationText')
          t.input '.pop-over-confirmation-button.primary.js-confirm-public', { type: 'button', value: t.mustacheVar('publicConfirmationConfirm') }
          t.input '.pop-over-confirmation-button.js-cancel-public', { type: 'button', value: t.mustacheVar('publicConfirmationCancel') }

        t.div '.check-div.u-clearfix', { style: 'margin-top: 10px;' }, ->
          t.input { type: 'checkbox', id: 'idKeepCards', name: 'cards', checked: true }
          t.label { for: 'idKeepCards' }, ->
            t.format 'keep-cards'
        t.mustacheBlock 'cardTemplatesFlagEnabled', ->
          t.div '.check-div.u-clearfix', { style: 'margin-top: 10px;' }, ->
            t.input { type: 'checkbox', id: 'idKeepTemplateCards', name: 'templates', checked: true }
            t.label { for: 'idKeepTemplateCards' }, ->
              t.format 'keep-template-cards'
        t.p '.quiet', ->
          if t.mustacheVar('toTemplate')
            t.format 'activity-and-members-will-not-be-copied-template'
          else
            t.format 'activity-and-members-will-not-be-copied'

        t.mustacheBlock 'willRemovePowerUps', ->
          t.p '.quiet', ->
            t.format 'power-ups-will-not-be-copied'

      t.input '.primary.wide.js-submit.disabled', { type: 'submit', value: t.l('create') }

      if t.mustacheVar('toTemplate')
        t.p '.quiet', { style: 'margin-top: 16px;' }, ->
          t.a '.js-open-convert', { href: '#' }, ->
            t.format 'convert-board-to-template-instead'

